import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';
import { MainRoutes } from '../../pages/main-routes.enum';

export const RoleGuard: CanActivateFn = (route, _state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return toObservable(userService.isInitialized).pipe(
    filter(Boolean),
    map(() => {
      const requiredRole = route.data.requiredRole || null;
      if (requiredRole == null) {
        return true;
      }

      const user = userService.user()!;
      if (user.hasRole(requiredRole)) {
        return true;
      }

      return router.createUrlTree([
        user.hasDriverRole() || user.hasHandoverRole() || user.hasAdminRole()
          ? MainRoutes.DEFAULT // Handled further by DefaultRedirectGuard.
          : MainRoutes.UNAUTHORIZED
      ]);
    })
  );
};
